/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function($)
{ 
  	/*
	$(".extraProducts input[type=radio]").change( function(){
      var parentSelector = $(".ProductForm");
      var parentsSelector = $(this).parents(".extraProducts");      
      //alert($(this).val());
      if($(this).val().indexOf("No") <= 0) {
        parentsSelector.find(".second_section").addClass("open");
        parentSelector.prepend(" <input class='extraProductHiddenField_"+$(this).val()+"' type='hidden' name='id[]' value='"+$(this).val()+"'>");
      } else {
        parentsSelector.find(".second_section").removeClass("open");
        parentSelector.find( ".extraProductHiddenField_"+ $(this).attr("data-id") ).remove();
      }
    } );
        
    $(".ProductForm input[type=radio]").change( function(){

        setTimeout( function() {

        var currentPrice = 0;

        currentPrice = parseInt( ( $(".ProductForm__Option select option:selected").attr("data-price")/100).toFixed(3) );

        var extraPrice = 0;

        $(".extraProducts").each( function(){

            var radio = $(this).find( "input[type=radio]:checked" );

            if( radio.val() != 'no' ) 
            {

                var variantPrice = parseInt( ( $(this).find("input[type=radio]:checked").attr("data-variant-price")/100).toFixed(3) );

                extraPrice = extraPrice + parseInt( variantPrice );

            }
  
          } );

          currentPrice = parseInt(currentPrice ) + parseInt( extraPrice );
  
          var priceListSelector = $(".ProductMeta__PriceList.Heading");
  
          priceListSelector.html("");
  
          priceListSelector.append('<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible="">£'+currentPrice+'</span>');

        }, 1000 );

    });
  	*/
  	

    $( "#accordion" ).accordion({
        collapsible: true
    });
  
  	/*$( document ).ready(function() {
      //$(".ui-accordion-content").hide();
  	});
    */
  
  	$( "#accordion" ).accordion({
      active: 2
    });
  
  	//$('#accordion').on('shown.bs.collapse', function () {
    //   console.log('Open....');
	//});
    	
  	//console.log($('.pplr-add-engraving-inside-1000 label').text());
  	//$('.pplr-add-engraving-inside-1000 label').text("Add engraving inside (Free)");
	
} );

jQuery(window).on('load', function() {
 // code here
  //console.log($('.pplr-add-engraving-inside-1000 label').text());
  $('.pplr-add-engraving-inside-1000 label').text("Add engraving inside (£10.00)");
  $('.pplr-add-engraving-outside-1000 label').text("Add engraving outside (£10.00)");
  //$('.pplr-add-engraving-inside-1000 label').text("Add engraving inside (Free)");
  //$('.pplr-add-engraving-outside-1000 label').text("Add engraving outside (Free)");
});